import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=561f1e93"
import script from "./Values.vue?vue&type=script&lang=js"
export * from "./Values.vue?vue&type=script&lang=js"
import style0 from "./Values.vue?vue&type=style&index=0&id=561f1e93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports